<template>
  <el-dialog :title="title" :visible="visible" width="40%" :before-close="handleClose">
    <el-image :src="payImg" class="pay-img"></el-image>
    <div slot="footer">
      <!-- <el-button @click="$emit('update:visible', false)">再想想</el-button> -->
      <el-button type="primary" @click="confirm('form')">支付完成 Payment completed</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    payImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    
    async confirm() {
      this.$emit("on-success");
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.pay-img {
  width: 430px;
  margin: 0 auto;
  display: block;
}
</style>
